import { BgxAbstractParam } from './abstract-param.decorator';

/**
 * Decorator that is used to define which parameter is the http response in a method
 */
export function BgxResponse(): (target: object, propertyKey: string | symbol, parameterIndex: number) => void {
  return BgxAbstractParam('response');
}
